'use strict';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueI18n from 'vue-i18n';
import locales from './locales.json';
import { sync } from 'vuex-router-sync';
import lang from './libs/lang';
import ua from './libs/user-agenet';

import App from './components/App';
import router from './router';
import store from './store';

// デバッグ出力
if(process.env.LOGGER_OUTPUT){
  window.logger = console.log.bind(window.console);
}else{
  window.logger = function(){
  };
}

// Mixpanel
(function(e, a){
  if(!a.__SV){
    var b = window;
    try{
      var c;
      var l;
      var i;
      var j = b.location;
      var g = j.hash;
      c     = function(a, b){
        return (l = a.match(RegExp(b + '=([^&]*)'))) ? l[1] : null;
      };
      g && c(g, 'state') && (i = JSON.parse(decodeURIComponent(c(g, 'state'))), i.action === 'mpeditor' && (b.sessionStorage.setItem('_mpcehash', g), history.replaceState(i.desiredHash || '', e.title, j.pathname + j.search)));
    }catch(m){
    }
    
    var k, h;
    window.mixpanel = a;
    a._i            = [];
    a.init          = function(b, c, f){
      function e(b, a){
        var c = a.split('.');
        c.length === 2 && (b = b[c[0]], a = c[1]);
        b[a] = function(){
          b.push([a].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      
      var d = a;
      typeof f !== 'undefined' ? d = a[f] = [] : f = 'mixpanel';
      d.people   = d.people || [];
      d.toString = function(b){
        var a = 'mixpanel';
        f !== 'mixpanel' && (a += '.' + f);
        b || (a += ' (stub)');
        return a;
      };
      
      d.people.toString = function(){
        return d.toString(1) + '.people (stub)';
      };
      
      k = 'disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(' ');
      
      for(h = 0; h < k.length; h++)e(d, k[h]);
      a._i.push([b, c, f]);
    };
    
    a.__SV  = 1.2;
    b       = e.createElement('script');
    b.type  = 'text/javascript';
    b.async = !0;
    b.src   = typeof MIXPANEL_CUSTOM_LIB_URL !== 'undefined' ? MIXPANEL_CUSTOM_LIB_URL : e.location.protocol === 'file:' && '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//) ? 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js' : '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
    c       = e.getElementsByTagName('script')[0];
    c.parentNode.insertBefore(b, c);
  }
})(document, window.mixpanel || []);
mixpanel.init(process.env.MIXPANEL_TOKEN);

// Google Analytics
if(process.env.NODE_ENV === 'production'){
  (function(i, s, o, g, r, a, m){
    i['GoogleAnalyticsObject'] = r;
    
    i[r]   = i[r] ||
      function(){
        (i[r].q = i[r].q || []).push(arguments);
      };
    i[r].l = 1 * new Date();
    
    a       = s.createElement(o);
    m       = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src   = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  ga('create', 'UA-88660054-1', 'auto');
  ga('send', 'pageview');
}
else{
  window.ga = function(){};
}

// グローバルミックスイン
Vue.mixin({
  mounted(){
    // MDLエレメントをアップグレード
    if(window.componentHandler){
      window.componentHandler.upgradeElements(this.$el);
    }
  }
});

// プラグインたち
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(VueYouTubeEmbed);

// i18nの設定
Vue.config.lang = lang.getLang();

Object.keys(locales).forEach(function(lang){
  Vue.locale(lang, locales[lang]);
});

// vuex-router-sync
sync(store, router);

/**
 * コンポーネント生成時のスクロール位置をコントロール
 */
router.beforeEach((to, from, next)=>{
  // iOSデバイス以外はafterEachの処理でいい感じに出来てる
  // iOSデバイスのみはスクロールを一番上に持ってくるようにする
  if(ua.isAppleDevice()){
    // MDLの .mdl-layout__content がスクロールしてるのでscrollBehaviorは使えないんだなぁ
    // 全部トップに持ってくるようにしてるけど、ちゃんとポジションを記憶できるようにしないといけない
    let $main = document.querySelector('.d3-layout-transparent');
    if($main){
      $main.scrollTop = 0;
    }
  }
  next();
});

/**
 * ページ遷移後にやること
 */
router.afterEach((to, from)=>{
  // ページが変わり次第mixpanelのpageViewイベントを発火
  if(to && to.name){
    mixpanel.track('viewPage', {
      name: to.name
    });
  }
  
  if(ua.isAppleDevice()){
    // iOSの場合はスクロールできなくなったりして変な感じ
    // もうMDLは新しいプロダクトで使わない！
    // iOSの場合はスクロールポジションを一番上に持ってくるようにする
  }
  else{
    // .mdl-layout__containerのheightをページによって変化させる
    // メインサービスじゃないAboutやSolutionページは縦に長いページを作りたい
    // しかしMDLはlayoutにするとheight:100%のdivの中にページが広がっていくため
    // vue-routerではスクロール位置の保持がうまくいかない
    // なので、文字が多いページではスクロール位置をちゃんと残せるように
    // mdl-layout__containerのheightをautoにしている
    // メインサービスページではheightは100%になっている
    // router.jsのmetaにisExtendContentDivを各urlで定義しているのでチェケラ
    let container = document.querySelector('.mdl-layout__container');
    
    if(container){
      if(to.matched.some(record=>record.meta.isExtendContentDiv)){
        // isExtendContentDivがtrue
        // つまりheight: 100%のデフォのままでok（styleでの指定をnullにするとcssのほうが効くようになる)
        container.style.height = null;
      }
      else{
        // height: autoで縦長ページに対応〜
        container.style.height = 'auto';
      }
    }
  }
});

new Vue({
  router: router,
  render: (h)=>{
    return h(App);
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js